module.exports = __webpack_public_path__ + "static/img/img_form_2_ko.a8b5d761.png";